import script from "./DashboardDataTable.vue?vue&type=script&setup=true&lang=ts&generic=TData%2C%20TValue"
export * from "./DashboardDataTable.vue?vue&type=script&setup=true&lang=ts&generic=TData%2C%20TValue"

const __exports__ = script;

export default __exports__